import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import { weDashboardSaleItems } from 'data/weraise-data/dashboard-data';
import createMarkup from 'helpers/createMarkup';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Notification from './Notification';

const EcomStatItem = ({ stat }) => {
  return (
    <div className="mb-3">
      <Flex alignItems="center">
        <h6 className="pb-1 mb-0 text-700 me-3">{stat.title} </h6>
        <CardDropdown />
      </Flex>
      <p
        className="font-sans-serif lh-1 mb-1 fs-2"
        dangerouslySetInnerHTML={createMarkup(stat.amount)}
      ></p>
      <div className="d-flex align-items-center">
        <h6 className="fs--1 text-500 mb-0">{stat.subAmount}</h6>
        <h6
          className={classNames('fs--2 ps-3 mb-0', {
            'text-success': stat.type === 'up',
            'text-danger': stat.type === 'down',
            'text-primary': stat.type === 'standard',
            'text-warning': stat.type === 'warning',
            'text-info': stat.type === 'pending'
          })}
        >
          <FontAwesomeIcon icon="caret-up" className="me-1" />
          {stat.percent}%
        </h6>
      </div>
    </div>
  );
};

const GreetingCard = ({ notifications }) => {
  return (
    <Card className="overflow-hidden pt-2">
      <FalconCardHeader
        title={<p className="text-700">Here is what happening today!</p>}
        light={false}
        titleTag="h6"
        className="pb-1"
        menuClassName="align-items-start"
        endEl={<CardDropdown btnRevealClass="btn-falcon-default" />}
      />

      <Card.Body className="p-0">
        <div className="p-3 w-xxl-75">
          <Row className="g-3 p-1">
            {weDashboardSaleItems.map((stat, index) => (
              <Col md={6} lg key={index}>
                <EcomStatItem
                  key={stat.title}
                  stat={stat}
                  index={index}
                  lastIndex={weDashboardSaleItems.length - 1}
                />
              </Col>
            ))}
          </Row>
        </div>
        <ul className="mb-0 list-unstyled">
          {notifications.map((notification, index) => (
            <Notification
              key={notification.id}
              notification={notification}
              isLast={notifications.length - 1 === index}
            />
          ))}
        </ul>
      </Card.Body>
    </Card>
  );
};

GreetingCard.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object)
};

EcomStatItem.propTypes = {
  stat: PropTypes.shape({
    title: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string,
    percent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string
  }),
  index: PropTypes.number,
  lastIndex: PropTypes.number
};

export default GreetingCard;
